import React, { useState, useEffect, useRef } from 'react';
import { Input, Icon } from 'antd';
import { XPathMappingRow as XPathMappingRowStyled } from './styles';
import VariableMentionPopup from '../EmailDesignPage/EmailBuilder/VariableMentionPopup';
import { BUSINESS_CONTRACTS as trans } from './translationValues';

const { TextArea } = Input;

const XPathMappingRowComponent = ({ xpathKey, variableValue, onXPathKeyChange, onVariableChange, onDelete, t, globalVariables = [], updateGlobalVariables, relationships = [] }) => {
  const [currentXPathKey, setCurrentXPathKey] = useState(xpathKey);
  const [popupPosition, setPopupPosition] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const variableInputRef = useRef(null);
  const previousValueRef = useRef(variableValue);
  const rowUuid = useRef(`xpath-row-${xpathKey}-${Date.now()}`);

  useEffect(() => {
    setCurrentXPathKey(xpathKey);
  }, [xpathKey]);

  useEffect(() => {
    previousValueRef.current = variableValue;
  }, [variableValue]);

  const handleXPathChange = (e) => {
    setCurrentXPathKey(e.target.value);
  };

  const handleXPathBlur = () => {
    if (currentXPathKey !== xpathKey) {
      onXPathKeyChange(xpathKey, currentXPathKey);
    }
  };

  const handleVariableInputChange = (e) => {
    const value = e.target.value;
    // Update the variable value immediately when user types
    onVariableChange(xpathKey, value);
    setSearchTerm(value);
    setPopupPosition({
      left: e.target.offsetLeft,
      bottom: e.target.offsetTop + e.target.offsetHeight,
      target: e.target,
      parentElement: e.target.parentElement
    });
  };

  const handleVariableInputClick = (e) => {
    e.stopPropagation();
    // Don't prevent default - allow normal input behavior
    previousValueRef.current = e.target.value;
    setSearchTerm(e.target.value);
    setPopupPosition({
      left: e.target.offsetLeft,
      bottom: e.target.offsetTop + e.target.offsetHeight,
      target: e.target,
      parentElement: e.target.parentElement
    });
  };

  const handleVariableInputBlur = () => {
    setPopupPosition(null);
    // Don't revert empty values - allow user to clear the field
    // The value is already persisted via handleVariableInputChange
  };

  const handleVariableSelect = (variable, allVariables) => {
    if (variable && variable.placeHolderText) {
      onVariableChange(xpathKey, variable.placeHolderText);
    }
  };

  const handlePopupHide = () => {
    setPopupPosition(null);
  };

  return (
    <XPathMappingRowStyled>
      <Input
        ref={variableInputRef}
        value={variableValue || ''}
        onChange={handleVariableInputChange}
        onClick={handleVariableInputClick}
        onBlur={handleVariableInputBlur}
        placeholder={t(trans.VARIABLE_PLACEHOLDER.key, trans.VARIABLE_PLACEHOLDER.value)}
        style={{ flex: 1 }}
      />
      <TextArea
        placeholder={t(trans.XPATH_PLACEHOLDER.key, trans.XPATH_PLACEHOLDER.value)}
        value={currentXPathKey}
        onChange={handleXPathChange}
        onBlur={handleXPathBlur}
        style={{ flex: 1 }}
        autosize={{ minRows: 2, maxRows: 6 }}
      />
      {popupPosition && (
        <VariableMentionPopup
          uuid={rowUuid.current}
          searchTerm={searchTerm}
          onVariableSelect={handleVariableSelect}
          onHide={handlePopupHide}
          position={popupPosition}
          popupPlacement="bottom"
          target={popupPosition.target}
          globalVariables={globalVariables}
          updateGlobalVariables={updateGlobalVariables}
          relationships={relationships}
        />
      )}
      <Icon type="delete" onClick={() => onDelete(xpathKey)} />
    </XPathMappingRowStyled>
  );
};

export default XPathMappingRowComponent;

